const styles = {
  textTransform: "initial",
  typography: "16_24_600",
  display: "inline-flex",
  minHeight: 0,
  minWidth: 0,
  gap: 6
}, classicTabStyles = {
  ".MuiTab-root": {
    ...styles,
    ":hover": {
      color: (t) => t.palette.tab.transparent.unselected.hover
    },
    ".MuiTab-iconWrapper": {
      width: 18,
      height: 18
    }
  },
  ".Mui-selected:hover": {
    color: (t) => t.palette.tab.transparent.selected.hover,
    cursor: "default"
  },
  ".MuiTabs-indicator": {
    height: 3
  },
  "&:has(.Mui-selected:hover) .MuiTabs-indicator": {
    backgroundColor: (t) => t.palette.tab.transparent.selected.hover
  },
  "&:has(.Mui-selected:disabled) .MuiTabs-indicator": {
    backgroundColor: (t) => t.palette.tab.transparent.selected.disabled
  }
}, rectangleTabStyles = {
  "&.MuiTabs-vertical": {
    ".MuiTab-root": {
      borderLeftWidth: 1,
      gap: 3,
      borderTopWidth: 0,
      "&:first-child": {
        borderTopWidth: 1
      },
      ".MuiTab-iconWrapper": {
        mb: 0
      }
    }
  },
  ".MuiTab-root": {
    ...styles,
    border: "1px solid",
    borderLeftWidth: 0,
    "&:first-child": {
      borderLeftWidth: 1
    },
    color: (t) => t.palette.tab.solid.unselected.content.default,
    borderColor: (t) => t.palette.tab.solid.unselected.border.default,
    backgroundColor: (t) => t.palette.tab.solid.unselected.bg.default,
    ":hover": {
      color: (t) => t.palette.tab.solid.unselected.content.hover,
      borderColor: (t) => t.palette.tab.solid.unselected.border.hover,
      backgroundColor: (t) => t.palette.tab.solid.unselected.bg.hover
    }
  },
  ".Mui-selected": {
    color: (t) => t.palette.tab.solid.selected.content.default,
    borderColor: (t) => t.palette.tab.solid.selected.border.default,
    backgroundColor: (t) => t.palette.tab.solid.selected.bg.default,
    ":hover": {
      color: (t) => t.palette.tab.solid.selected.content.hover,
      borderColor: (t) => t.palette.tab.solid.selected.border.hover,
      backgroundColor: (t) => t.palette.tab.solid.selected.bg.hover,
      cursor: "default"
    }
  },
  ".Mui-disabled": {
    color: (t) => t.palette.tab.solid.unselected.content.disabled,
    borderColor: (t) => t.palette.tab.solid.unselected.border.disabled,
    backgroundColor: (t) => t.palette.tab.solid.unselected.bg.disabled,
    ":hover": {
      color: (t) => t.palette.tab.solid.unselected.content.disabled,
      borderColor: (t) => t.palette.tab.solid.unselected.border.disabled,
      backgroundColor: (t) => t.palette.tab.solid.unselected.bg.disabled
    }
  },
  ".Mui-disabled.Mui-selected": {
    color: (t) => t.palette.tab.solid.selected.content.disabled,
    borderColor: (t) => t.palette.tab.solid.selected.border.disabled,
    backgroundColor: (t) => t.palette.tab.solid.selected.bg.disabled,
    ":hover": {
      color: (t) => t.palette.tab.solid.selected.content.disabled,
      borderColor: (t) => t.palette.tab.solid.selected.border.disabled,
      backgroundColor: (t) => t.palette.tab.solid.selected.bg.disabled
    }
  },
  ".MuiTabs-indicator": {
    visibility: "hidden",
    transition: "none"
  }
}, tabsStylesTypeMap = {
  primary: {
    ...classicTabStyles,
    ".MuiTab-root": {
      ...classicTabStyles[".MuiTab-root"],
      p: "12px 24px"
    }
  },
  secondary: {
    ...classicTabStyles,
    ".MuiTab-root": {
      ...classicTabStyles[".MuiTab-root"],
      p: 12
    }
  },
  rectangle: {
    ...rectangleTabStyles,
    ".MuiTab-root": {
      ...rectangleTabStyles[".MuiTab-root"],
      p: "12px 24px",
      ".MuiTab-iconWrapper": {
        width: 18,
        height: 18
      }
    }
  },
  square: {
    ...rectangleTabStyles,
    ".MuiTab-root": {
      ...rectangleTabStyles[".MuiTab-root"],
      width: 102,
      height: 102,
      p: "0 6px",
      ".MuiTab-iconWrapper": {
        width: 24,
        height: 24
      }
    }
  }
};
export {
  tabsStylesTypeMap
};
//# sourceMappingURL=styles.js.map
